import { Injectable } from '@angular/core';

/**
 * Class representing the Redirect service
 */
@Injectable()
export class RedirectService {
  private _lmsPath = '';

  set lmsPath(newLmsPath: string) {
    this._lmsPath = newLmsPath;
  }

  get lmsPath(): string {
    return this._lmsPath;
  }
}
